import { useLocation } from "react-router-dom";
import { useSelectedMarket } from "core/selectors/marketSelectors";
import { DEFAULT_LANG } from "helpers/language";

export type SelectedLanguage = {
  name: string;
  codeISO2: string;
  codeISO3: string;
  languageId: number;
};

// TODO: move the hook, rename the file
export const useIcbtLanguage = (): {
  name: string;
  codeISO2: string;
  codeISO3: string;
  languageId: number;
} => {
  const location = useLocation();
  const market = useSelectedMarket();
  const userSelectedLanguage: SelectedLanguage | undefined =
    market?.languages.find(
      (language) =>
        language.codeISO2.toLowerCase() === DEFAULT_LANG.toLowerCase(),
    );

  const icbtLanguage = location.state?.selectedLanguage;
  const defaultLanguage =
    market &&
    market.languages.find(
      ({ languageId }) => languageId === market.defaultLanguageId,
    ) &&
    market.languages[0];

  return icbtLanguage ?? userSelectedLanguage ?? defaultLanguage;
};
